/* Grass Mats Co — product page behaviour (gallery, lightbox, options, calculator, add to basket, sticky bar). */
(function () {
  'use strict';

  function money(n, cur) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP' }).format(n); }
    catch (e) { return '£' + Number(n).toFixed(2); }
  }

  // Length and width in metres of one unit, read from a variant title such as "1.0m x 1.5m x 23mm", "6ft x 4ft", "36inch x 36inch", "910mm x 910mm".
  function parseDims(title) {
    var t = String(title || '').toLowerCase().replace(/×/g, 'x'), m;
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*m(?:\s*wide)?\s*x\s*(\d+(?:\.\d+)?)\s*m(?!m)/))) return [+m[1], +m[2]];
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:ft|feet|')\s*x\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|')/))) return [m[1] * 0.3048, m[2] * 0.3048];
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:inch|in|")\s*x\s*(\d+(?:\.\d+)?)\s*(?:inch|in|")/))) return [m[1] * 0.0254, m[2] * 0.0254];
    if ((m = t.match(/(\d{3,4})\s*mm\s*x\s*(\d{3,4})\s*mm/))) return [m[1] / 1000, m[2] / 1000];
    return null;
  }
  // Area in m² of one unit.
  function parseArea(title) {
    var d = parseDims(title);
    return d ? d[0] * d[1] : 0;
  }
  // Whole units needed to cover an l × w area, laid in a grid in whichever orientation needs fewer.
  // Dividing total area by unit area can come up short, because part-units can't fill the gaps.
  function gridCount(l, w, d) {
    function fit(x, s) { return Math.max(1, Math.ceil(x / s - 1e-9)); }
    var a = { along: fit(l, d[0]), across: fit(w, d[1]) };
    var b = { along: fit(l, d[1]), across: fit(w, d[0]) };
    var g = a.along * a.across <= b.along * b.across ? a : b;
    g.n = g.along * g.across;
    return g;
  }
  function thick(title) {
    var all = String(title || '').toLowerCase().match(/\d+\s*mm/g);
    return all ? all[all.length - 1].replace(/\s/g, '') : '';
  }
  function hasPegs(title) {
    var t = String(title || '').toLowerCase();
    return t.indexOf('without') < 0 && t.indexOf('peg') > -1;
  }
  function fmtArea(a) { return (Math.round(a * 100) / 100).toString(); }

  function dispatchDate(days, hols) {
    var d = new Date();
    function iso(x) { return x.getFullYear() + '-' + ('0' + (x.getMonth() + 1)).slice(-2) + '-' + ('0' + x.getDate()).slice(-2); }
    function work(x) { var w = x.getDay(); return w !== 0 && w !== 6 && hols.indexOf(iso(x)) < 0; }
    while (!work(d)) d.setDate(d.getDate() + 1);
    var added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (work(d)) added++; }
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  /* ---------- Gallery + lightbox ---------- */
  function initGallery(g) {
    if (!g || g.__gmc) return null;
    g.__gmc = true;
    var track = g.querySelector('[data-gmc-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gmc-thumb]'));
    var thumbWrap = g.querySelector('[data-gmc-thumbs]');
    var count = g.querySelector('[data-gmc-count]');
    var idx = 0;

    function setActive(i) {
      idx = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var th = thumbs[i];
      if (th && thumbWrap) {
        var left = th.offsetLeft - (thumbWrap.clientWidth - th.clientWidth) / 2;
        thumbWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx) setActive(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = g.querySelector('[data-gmc-prev]'), next = g.querySelector('[data-gmc-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    // Lightbox
    var lb = g.querySelector('[data-gmc-lb]');
    var zooms = Array.prototype.slice.call(g.querySelectorAll('[data-gmc-zoom]'));
    var full = zooms.map(function (z) { return z.getAttribute('data-full'); });
    var lbIdx = 0;
    function lbShow(i) {
      lbIdx = (i + full.length) % full.length;
      lb.querySelector('img').src = full[lbIdx];
      var srcImg = zooms[lbIdx].querySelector('img');
      if (srcImg) lb.querySelector('img').alt = srcImg.alt;
      lb.querySelector('[data-gmc-lb-count]').textContent = (lbIdx + 1) + ' / ' + full.length;
    }
    zooms.forEach(function (z, n) {
      z.addEventListener('click', function () {
        if (!lb || typeof lb.showModal !== 'function') { window.open(full[n], '_blank'); return; }
        lbShow(n);
        lb.showModal();
      });
    });
    if (lb) {
      lb.querySelector('[data-gmc-lb-close]').addEventListener('click', function () { lb.close(); });
      lb.querySelector('[data-gmc-lb-prev]').addEventListener('click', function () { lbShow(lbIdx - 1); });
      lb.querySelector('[data-gmc-lb-next]').addEventListener('click', function () { lbShow(lbIdx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('gmc-lb__in')) lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
        if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
      });
    }
    setActive(0);

    return {
      goToMedia: function (id) {
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(id)) { go(i); return; }
        }
      }
    };
  }

  /* ---------- Buy box ---------- */
  function initPDP(root) {
    if (!root || root.__gmc) return;
    root.__gmc = true;
    var cfg = JSON.parse(root.querySelector('[data-gmc-json]').textContent);
    var V = cfg.variants, sid = cfg.sid, cur = cfg.currency;
    var hols = String(cfg.hols || '').split(',').map(function (s) { return s.trim(); });
    function $(s) { return root.querySelector(s); }
    var gallery = initGallery(root.querySelector('[data-gmc-gal]'));
    var form = $('[data-gmc-form]'), idEl = $('[data-gmc-id]'), qtyEl = $('[data-gmc-qty]');
    var addBtn = $('[data-gmc-add]'), buyNow = $('[data-gmc-buynow]');
    var priceEl = $('[data-gmc-price]'), wasEl = $('[data-gmc-was]'), saveEl = $('[data-gmc-save]'), unitEl = $('[data-gmc-unitprice]');
    var stockEl = $('[data-gmc-stock]'), stockText = $('[data-gmc-stock-text]'), dispatchEl = $('[data-gmc-dispatch]');
    var calcBox = $('[data-gmc-calc]'), lenEl = $('[data-gmc-len]'), widEl = $('[data-gmc-wid]'), calcOut = $('[data-gmc-calc-out]'), calcNote = $('[data-gmc-calc-note]');
    var totalEl = $('[data-gmc-total]'), shipText = $('[data-gmc-ship-text]'), shipBar = $('[data-gmc-ship-bar]');
    var addedBox = $('[data-gmc-added]'), addedText = $('[data-gmc-added-text]'), errBox = $('[data-gmc-error]');
    var pegDelta = $('[data-gmc-pegdelta]');
    var sticky = root.querySelector('[data-gmc-sticky]');
    var stickyPrice = sticky && sticky.querySelector('[data-gmc-sticky-price]');
    var stickyVar = sticky && sticky.querySelector('[data-gmc-sticky-variant]');
    var addLabel = addBtn ? addBtn.textContent : 'Add to basket';
    var cartTotal = 0, justAdded = false, lastMedia = null;

    function checked(name) { var el = root.querySelector('input[name="' + name + '-' + sid + '"]:checked'); return el ? el.value : null; }
    function qty() { var q = parseInt(qtyEl.value, 10); if (!(q > 0)) q = 1; return Math.min(q, 9999); }
    function byId(id) { for (var i = 0; i < V.length; i++) if (String(V[i].id) === String(id)) return V[i]; return null; }

    function selected() {
      if (cfg.mode === 'split') {
        var t = checked('gmc-t'), pg = checked('gmc-p');
        var m = V.filter(function (v) { return !t || thick(v.title) === t; });
        if (pg !== null) {
          var m2 = m.filter(function (v) { return hasPegs(v.title) === (pg === '1'); });
          if (m2.length) m = m2;
        }
        return m[0] || V[0];
      }
      if (cfg.mode === 'cards') return byId(checked('gmc-v')) || V[0];
      return V[0];
    }

    function update() {
      var v = selected(), q = qty(), unit = v.price / 100, line = unit * q;
      var dims = parseDims(v.title), area = dims ? dims[0] * dims[1] : 0;
      idEl.value = v.id;
      priceEl.textContent = money(unit, cur);
      if (v.compare > v.price) {
        wasEl.hidden = false; wasEl.textContent = money(v.compare / 100, cur);
        saveEl.hidden = false; saveEl.textContent = 'Save ' + money((v.compare - v.price) / 100, cur) + ' (' + Math.round((1 - v.price / v.compare) * 100) + '%)';
      } else { wasEl.hidden = true; saveEl.hidden = true; }
      if (area > 0) {
        unitEl.hidden = false;
        unitEl.textContent = money(unit / area, cur) + ' per m² · each covers ' + fmtArea(area) + ' m²';
      } else unitEl.hidden = true;

      if (calcBox) {
        calcBox.hidden = !(area > 0);
        calcBox.setAttribute('data-area', area);
        calcBox.setAttribute('data-dims', dims ? dims.join(',') : '');
        if (calcNote) {
          var one = cfg.noun.replace(/s$/, '');
          calcNote.textContent = !(area > 0) ? ''
            : cfg.grid ? 'Each ' + one + ' is ' + fmtArea(dims[0]) + 'm × ' + fmtArea(dims[1]) + 'm (' + fmtArea(area) + ' m²). We count whole ' + cfg.noun + ' along the length and across the width, so you are never short.'
            : 'Each ' + one + ' covers ' + fmtArea(area) + ' m². We round up so you are never short.';
        }
      }

      if (stockEl) {
        stockEl.classList.toggle('is-out', !v.available);
        stockText.textContent = v.available ? 'In stock' : 'Sold out';
      }
      addBtn.disabled = !v.available;
      if (buyNow) buyNow.disabled = !v.available;
      addBtn.textContent = v.available ? addLabel : 'Sold out';

      totalEl.textContent = money(line, cur);
      if (cfg.freeAt > 0 && shipText) {
        var basket = cartTotal / 100 + (justAdded ? 0 : line);
        var left = cfg.freeAt - basket;
        shipText.innerHTML = left > 0
          ? 'Add <b>' + money(left, cur) + '</b> more for <b>free UK delivery</b>'
          : '<b>Free UK delivery</b> on this order';
        if (shipBar) shipBar.style.width = Math.min(100, (basket / cfg.freeAt) * 100) + '%';
      }

      if (pegDelta) {
        var t = thick(v.title);
        var a = V.filter(function (x) { return thick(x.title) === t && hasPegs(x.title); })[0];
        var b = V.filter(function (x) { return thick(x.title) === t && !hasPegs(x.title); })[0];
        pegDelta.textContent = (a && b) ? '+' + money((a.price - b.price) / 100, cur) + ' per mat' : '';
      }

      if (stickyPrice) stickyPrice.textContent = money(line, cur);
      if (stickyVar) stickyVar.textContent = (q > 1 ? q + ' × ' : '') + v.title;

      if (gallery && v.media && v.media !== lastMedia) { lastMedia = v.media; gallery.goToMedia(v.media); }
      if (window.history && history.replaceState && cfg.mode !== 'single') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }
    }

    function calc() {
      var area = parseFloat(calcBox.getAttribute('data-area')) || 0;
      var dims = String(calcBox.getAttribute('data-dims') || '').split(',').map(parseFloat);
      var l = parseFloat(lenEl.value), w = parseFloat(widEl.value);
      if (area > 0 && dims[0] > 0 && dims[1] > 0 && l > 0 && w > 0) {
        // Rigid products (cfg.grid) can't be cut to fit, so count whole units; cuttable ones go by area.
        var a = l * w, g = cfg.grid ? gridCount(l, w, dims) : null;
        var n = g ? g.n : Math.max(1, Math.ceil(a / area - 1e-9));
        var layout = g && g.along > 1 && g.across > 1 ? ', laid ' + g.along + ' along the length × ' + g.across + ' across the width' : '';
        qtyEl.value = n;
        calcOut.innerHTML = 'You need <b>' + n + ' ' + (n === 1 ? cfg.noun.replace(/s$/, '') : cfg.noun) + '</b>' + layout + ', covering ' + fmtArea(n * area) + ' m² (your area is ' + fmtArea(a) + ' m²).';
      } else {
        calcOut.textContent = calcOut.getAttribute('data-default');
      }
      justAdded = false;
      update();
    }

    function refreshCart() {
      return fetch(cfg.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; update(); })
        .catch(function () {});
    }

    function add() {
      var v = selected(), q = qty();
      errBox.hidden = true;
      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Adding…';
      fetch(cfg.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: q }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sorry, we could not add this to your basket.');
          addedText.textContent = q + ' × ' + v.title;
          addedBox.hidden = false;
          justAdded = true;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return refreshCart();
        })
        .catch(function (e) { errBox.textContent = e.message; errBox.hidden = false; })
        .then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.textContent = selected().available ? addLabel : 'Sold out';
        });
    }

    root.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        justAdded = false; addedBox.hidden = true; update();
        // Size changed after using the calculator: recalculate so the quantity matches the new size's coverage.
        if (lenEl && parseFloat(lenEl.value) > 0 && parseFloat(widEl.value) > 0) calc();
      }
    });
    qtyEl.addEventListener('input', function () { justAdded = false; update(); });
    qtyEl.addEventListener('blur', function () { qtyEl.value = qty(); update(); });
    if (lenEl) { lenEl.addEventListener('input', calc); widEl.addEventListener('input', calc); }
    Array.prototype.forEach.call(root.querySelectorAll('[data-gmc-step]'), function (b) {
      b.addEventListener('click', function () {
        qtyEl.value = Math.max(1, qty() + parseInt(b.getAttribute('data-gmc-step'), 10));
        justAdded = false;
        update();
      });
    });
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.hasAttribute('data-gmc-buynow')) return; // Buy it now posts normally and goes to checkout
      e.preventDefault();
      if (!addBtn.disabled) add();
    });

    if (dispatchEl && cfg.dispatchDays > 0) {
      dispatchEl.textContent = 'Order now for dispatch by ' + dispatchDate(cfg.dispatchDays, hols);
    }

    if (sticky && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-gmc-sticky-add]');
      stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        add();
      });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyBtn.tabIndex = on ? 0 : -1;
      }).observe(addBtn);
    }

    update();
    refreshCart();
  }

  /* ---------- Details section ---------- */
  function initDetails(root) {
    if (!root || root.__gmc) return;
    root.__gmc = true;
    var cur = root.getAttribute('data-currency') || 'GBP';
    Array.prototype.forEach.call(root.querySelectorAll('[data-gmc-perm2]'), function (td) {
      var a = parseArea(td.getAttribute('data-title'));
      td.textContent = a > 0 ? money(td.getAttribute('data-price') / 100 / a, cur) : '—';
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-gmc-navitem] a'), function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      if (!id || !document.getElementById(id)) a.parentNode.hidden = true;
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gmc-pdp]'), initPDP);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gmc-details]'), initDetails);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
